import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const StateMessage = styled.div`
    align-items: center;
    color: ${theme.colors.foreground.subtle};
    display: flex;
    font-size: ${theme.fontSizes[14]};
    min-height: 32px;
    padding: 0 ${theme.space[8]};
`;
